import debounce from 'lodash-es/debounce';
import { batch } from '@tmapy/redux';
import { LAYER_IDS } from '@tmapy/config';
import { actionAddHiddenFeatures, actionSetLayerFeatureHighlight, actionSetLayerFeatures, getFeatureFromLayer, containHighlight, getFeaturesFromLayer, actionInvalidateVectorTileLayer, } from '@tmapy/mapcore';
import { PREPARE_LOAD_FEATURES } from '../constants';
import { actionUnhideTileFeaturesByLayer } from './actionUnhideTileFeaturesByLayer';
import { actionUpdateLoadedFeatures } from './components';
const debouncedLoadFeaturesForEdit = debounce(async (dispatch, getState, filteredFeaturesForLoad) => {
    const state = getState();
    if (!containHighlight(filteredFeaturesForLoad, state.mapCore.interaction.highlightedFeatures)) {
        return;
    }
    if (filteredFeaturesForLoad.length > 0) {
        dispatch(actionPrepareLoadFeatures(filteredFeaturesForLoad));
    }
}, 150);
// TODO OldValue vs. OLDValues[]
/**
 * Middleware action called after FEATURE_HIGHLIGHT
 */
export const actionLoadFeaturesForEdit = (highlightPayload, highlightMeta) => async (dispatch, getState) => {
    const state = getState();
    const removeFeatures = highlightMeta.oldValues.filter((oldFeature) => !highlightPayload.highlightedFeatures.some((newFeature) => newFeature.layerId === oldFeature.layerId &&
        newFeature.featureId === oldFeature.featureId));
    removeFeatures.forEach((removeFeature) => {
        if (removeFeature.layerId === LAYER_IDS.EDIT_TOOLS_HIGHLIGHT) {
            const feature = getFeatureFromLayer(state.mapCore.layers, removeFeature.layerId, removeFeature.featureId);
            if (feature) {
                dispatch(actionUnhideTileFeaturesByLayer(LAYER_IDS.EDIT_TOOLS_HIGHLIGHT, feature.properties?._originLayerId, [removeFeature.featureId]));
            }
        }
    });
    // LOAD FILTERED
    const filteredFeaturesForLoad = highlightPayload.highlightedFeatures.filter((highlightedFeature) => highlightedFeature.featureId &&
        highlightedFeature.layerId !== LAYER_IDS.EDIT_TOOLS_HIGHLIGHT &&
        highlightedFeature.layerId !== LAYER_IDS.EDIT_TOOLS_MODIFY);
    if (filteredFeaturesForLoad.length) {
        await debouncedLoadFeaturesForEdit(dispatch, getState, filteredFeaturesForLoad);
    }
};
export const actionPrepareLoadFeatures = (payload) => ({
    type: PREPARE_LOAD_FEATURES,
    payload,
});
export const actionAfterLoadSuccess = (features) => (dispatch, getState) => {
    const loadedFeatures = features.filter((feature) => !!feature);
    const state = getState();
    const coordinate = state.mapCore.interaction.coordinate;
    const highlightFeatures = getFeaturesFromLayer(state.mapCore.layers, LAYER_IDS.EDIT_TOOLS_HIGHLIGHT) ?? [];
    const formatedFeatures = loadedFeatures
        .filter((feature) => !!feature.data)
        .map((loadedFeature) => ({
        ...loadedFeature.data,
        properties: {
            ...loadedFeature.data?.properties,
            _originLayerId: loadedFeature.layerId,
            _crs: loadedFeature.data?.crs,
        },
    }));
    const newHighlightFeatures = highlightFeatures.concat(formatedFeatures);
    batch('actionAfterLoadSuccess', () => {
        loadedFeatures.forEach((loadedFeature) => {
            dispatch(actionAddHiddenFeatures(loadedFeature.layerId, loadedFeature.featureId ? [loadedFeature.featureId] : []));
        });
        dispatch(actionSetLayerFeatures(LAYER_IDS.EDIT_TOOLS_HIGHLIGHT, newHighlightFeatures));
        dispatch(actionSetLayerFeatureHighlight({
            highlightedFeatures: newHighlightFeatures.map((loadedFeature) => ({
                layerId: LAYER_IDS.EDIT_TOOLS_HIGHLIGHT,
                featureId: loadedFeature.id,
            })),
            coordinate,
        }));
        const deletedFeatureLayers = new Set(loadedFeatures
            .map((feature) => (!feature.data ? feature.layerId : null))
            .filter((layerId) => layerId));
        if (deletedFeatureLayers.size) {
            Array.from(deletedFeatureLayers).forEach((layerId) => dispatch(actionInvalidateVectorTileLayer(layerId)));
        }
        dispatch(actionUpdateLoadedFeatures(loadedFeatures));
    });
};
//# sourceMappingURL=loadFeaturesForEdit.js.map